<template>
	<div class="index-page">
		<NavMenu></NavMenu>
		<div class="index-text">
			<img :src="currentImage" alt="">
		</div>
		<div class="footer">
			<div>Copyright © 2025 Gong Inc.</div> 
			<div>All rights reserved.</div>
		</div>
	</div>
</template>

<script>
	import NavMenu from '../components/nav.vue';
	export default {
		name: 'index',
		components: {
			NavMenu,
		},
		data() {
			return {
				images: [
					require('../assets/img/text1.png'),
					require('../assets/img/text2.png'),
					require('../assets/img/text3.png'),
					require('../assets/img/text4.png'),
					require('../assets/img/text5.png'),
					require('../assets/img/text6.png'),
					require('../assets/img/text7.png'),
					require('../assets/img/text8.png'),
					require('../assets/img/text9.png'),
				],
				currentIndex: 0,
				intervalId: null,
			}
		},
		computed: {
		    currentImage() {
				return this.images[this.currentIndex];
		    },
		},
		mounted() {
			this.intervalId = setInterval(this.nextImage, 1000);
		},
		methods: {
			nextImage() {
				if (this.currentIndex === this.images.length -1) return;
				this.currentIndex += 1;
			}
		},
		beforeDestroy() {
		    clearInterval(this.intervalId); // 清除定时器，避免内存泄漏
		}
	}
</script>

<style scoped>
	.index-page {
		background-color: #000;
		width: 100%;
		height: 100vh;
		position: relative;
		/* background: url('../assets/index_bj.png') no-repeat; */
		background-image: url('../assets/img/bj.png');
		background-repeat: no-repeat; /* 不重复 */
		background-size: cover; /* 覆盖整个元素 */
		background-position: center; /* 图片居中 */
		
	}
	.index-text {
		width: 50px;
		position: absolute;
		left: 50%;
		top: 30%;
		transform: translateX(-50%);
	}
	.index-text img {
		width: 50px;
	}
	.footer {
		position: absolute;
		bottom: 26px;
		width: 100%;
		text-align: center;
		color: rgba(0255, 255, 255, .45);
		font-size: 10px;
	}
</style>